module.exports = __webpack_public_path__ + "static/img/ctimg71.d90e520.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ctimaging/ctimg71.png
// module id = Q3nm
// module chunks = 5